import React, { useRef } from "react";
import { Box, Card } from '@curves/ui-base';

import useEChart from "@Util/hook/useEChart";
import ChartSkeletonLoading from "@Local/Dashboard/Components/ChartSkeletonLoading";
import { tooltipFormatter, adaptPie } from "@Local/Dashboard/dashboard.util";
import { formatCurrencyFn } from "@Util/utils";
const COLOR_CONFIG = [{ color: "#4C0073" }, { color: "#7E2E9C" }, { color: "#94A3B8" }, { color: "#CBD5E1" }, { color: "#E2E8F0" }];
/********* 年度平均客單價 *********/
const YearlyAverageSpend = React.forwardRef((props, ref) => {
	const chartDomRef = useRef(null);
	const {
		sourceData = {
			xAxis: ["A (5K~8K)", "B (3K~5K)", "C (1K~3K)", "D (<1K)", "S (8K+)"],
			data: [82, 45, 35, 78, 125],
		},
	} = props;
	const { data = [], centerValueText = "" } = adaptPie(sourceData, COLOR_CONFIG);
	const centerValue = formatCurrencyFn(Number(centerValueText ?? 0));
	const isLoading = data.length === 0;
	const title = "年度平均客單價";
	const option = {
		title: {
			text: title,
			left: 24,
			top: 20,
			textStyle: {
				fontSize: 20,
				fontWeight: 600,
				color: "#1F2937",
			},
		},
		tooltip: {
			trigger: "item",
			formatter: tooltipFormatter,
		},
		legend: {
			bottom: 10,
			left: "center",
			textStyle: {
				fontSize: 14,
				fontWeight: 600,
				color: "#111827",
			},
		},
		graphic: [
			{
				type: "text",
				left: "center",
				top: "43%",
				style: {
					text: "平均客單",
					fill: "#94A3B8",
					fontSize: 12,
					textAlign: "center",
				},
			},
			{
				type: "text",
				left: "center",
				top: "50%",
				style: {
					text: `{value|${centerValue}}{unit| 元}`,
					textAlign: "center",
					rich: {
						value: {
							fill: "#4C0073",
							fontSize: 20,
							fontWeight: 700,
						},
						unit: {
							fill: "#4C0073",
							fontSize: 10,
							fontWeight: 600,
						},
					},
				},
			},
		],
		series: [
			{
				type: "pie",
				radius: ["40%", "55%"],
				center: ["50%", "50%"],
				padAngle: 3,
				avoidLabelOverlap: false,
				label: { show: false },
				labelLine: { show: false },
				itemStyle: {
					borderRadius: 8,
				},
				data: data,
			},
		],
	};
	useEChart(chartDomRef, option);
	return (
		<Card style={{ width: "100%", height: "100%" }}>
			<Card.CardContent style={{ width: "100%", height: "100%" }}>
				{isLoading ? <ChartSkeletonLoading /> : <Box ref={chartDomRef} style={{ width: "100%", height: "100%" }}></Box>}
			</Card.CardContent>
		</Card>
	);
});
export default YearlyAverageSpend;
